export enum NationalLinearScheduleEnum {
    "uploadExistingSchedule" = 1,
    "noSchedule" = 2
}